module.exports = __webpack_public_path__ + "img/logo.d8100993.png";